import { SpherePlatformAppPaths } from '@sphere/platform';

export const PATHS: SpherePlatformAppPaths = {
    ['CALENDAR_MANAGER_PATH']: 'calendars',
    ['CALENDAR_MANAGER_CALENDARS_PATH']: 'overview'
};
